
import Vue from "vue";
import { Sale, SaleHistory } from "@/models/base";

interface IStatus {
	StatusReasonCode:string | null;
	StatusReason:string | null;
	IsAction:boolean;
	Conditions:ICondition[];
}

interface ICondition {
	AttributeID:string;
	Description:string | null;
}

export default Vue.extend({
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true,
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		responseDescription():string {
			return this.event.Props[1];
		},
		responseStatus():IStatus[] {
			if (!this.event.Props[2]) return [];
			return JSON.parse(this.event.Props[2]) as IStatus[];
		}
	},
	methods: {
		statusReasonCodeToString(status:IStatus):string{
			if (status.IsAction){
				return this.$ct(`models.SaleHistoryPeppolInvoiceResponseReceived.ActionReasonCodes.${status.StatusReasonCode}`).toString();
			}
			return this.$ct(`models.SaleHistoryPeppolInvoiceResponseReceived.ClarificationReasonCodes.${status.StatusReasonCode}`).toString();
		}
	},
});

